import { CmsApiPersonaQuizBlockData } from 'modules/cms/api/types/CmsApiPersonaQuiz';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpPersonaQuizBlock } from './CmsAmpPersonaQuizBlock';
import { CmsPersonaQuizBlock } from './CmsPersonaQuizBlock';

export const CmsPersonaQuizBlockMapping: CmsBlockMapping<CmsApiPersonaQuizBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsPersonaQuizBlock,
    AmpComponent: CmsAmpPersonaQuizBlock,
  };
